/**
 * 课程标准 api
 * 课程标准api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The FragmentResVo model module.
   * @module course_standard/model/FragmentResVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>FragmentResVo</code>.
   * @alias module:course_standard/model/FragmentResVo
   * @class
   */
  var exports = function() {
    var _this = this;





  };

  /**
   * Constructs a <code>FragmentResVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:course_standard/model/FragmentResVo} obj Optional instance to populate.
   * @return {module:course_standard/model/FragmentResVo} The populated <code>FragmentResVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'fragmentId')) {
        obj['fragmentId'] = ApiClient.convertToType(data['fragmentId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'mediaUrl')) {
        obj['mediaUrl'] = ApiClient.convertToType(data['mediaUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 资源id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 碎片id
   * @member {Integer} fragmentId
   */
  exports.prototype['fragmentId'] = undefined;
  /**
   * 媒体url
   * @member {String} mediaUrl
   */
  exports.prototype['mediaUrl'] = undefined;
  /**
   * 媒体资源类型 1:视频；2音频
   * @member {Integer} type
   */
  exports.prototype['type'] = undefined;



  export default exports;
;


